'use strict';

angular.module('cakeapp')
.directive('onlyNumbers', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            var pattern = /[^0-9\u06F0-\u06F90-9!\\"#$%&'()*+,\-.\/:;<=>?@\[\]^_`{|}~]*/g;
            function fromUser(text) {
                if (!text)
                    return text;
                var transformedInput = text.replace(pattern, '');
                transformedInput = transformedInput
                .replace(/۱/g,'1')
                .replace(/۲/g,'2')
                .replace(/۳/g,'3')
                .replace(/۴/g,'4')
                .replace(/۵/g,'5')
                .replace(/۶/g,'6')
                .replace(/۷/g,'7')
                .replace(/۸/g,'8')
                .replace(/۹/g,'9')
                .replace(/۰/g,'0')
                if (transformedInput !== text) {
                    ngModelCtrl.$setViewValue(transformedInput);
                    ngModelCtrl.$render();
                }
                return transformedInput;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
}]);